export default ({ stepsOptions, groupsOptions }) => [
    {
        label: 'Name',
        key: 'name',
        type: 'string',
        elementProps: {
            isRequired: true,
            placeholder: 'Dashboard name',
        },
    },
    {
        label: 'Step',
        key: 'step',
        type: 'select',
        elementProps: {
            isRequired: true,
            fullWidth: true,
            placeholder: 'Step',
            options: stepsOptions,
        },
    },
    {
        label: 'Group',
        key: 'group',
        type: 'select',
        elementProps: {
            isRequired: false,
            fullWidth: true,
            placeholder: 'Group',
            options: groupsOptions,
        },
    },
    {
        label: 'Supervisor group',
        key: 'supervisorGroup',
        type: 'select',
        elementProps: {
            isRequired: false,
            fullWidth: true,
            placeholder: 'Supervisor group',
            options: groupsOptions,
        },
    },
];
